module.exports = __webpack_public_path__ + "static/media/locorobo-logo.9c89f787.svg";